
export const Heading = {
    heading: " ",
    translate: "sidebar.heading.HEADER",
};

export const dashboard = {
    name: "dashboard",
    icon: "icon-dashboard",
    path: "/dashboard",
    id: 15
};

export const po_visibility = {
    name: "orderVisibility",
    icon: "icon-po-visibility",
    path: "/po-visibility",
    id: 2
};

export const po_management = {
    name: "purchase_orders",
    icon: "icon-po-management",
    path: "/po-management",
    id: 10
};

export const supplier_management = {
    name: "supplier_management_menu",
    icon: "icon-supplier-management-2",
    path: "/supplier-management",
    id: 13
};

export const entity_association = {
    name: "association_of_entities",
    icon: "icon-entity-association",
    path: "/entity-association",
    id: 14
};

export const transport_plans = {
    name: "transports_plans",
    icon: "icon-transport-plans",
    path: "/transport-plans",
    id: 1
};

export const shipments_visibility = {
    name: "shipmentsVisibility",
    icon: "icon-shipments-visibility",
    path: "/shipment-visibility",
    id: 3
};

export const finance = {
    name: "finance",
    icon: "icon-finance",
    path: "/finance",
    id: 6
};

export const time_sensitive = {
    name: "time_sensitive",
    icon: "icon-quotes",
    path: "/quotes",
    id: 12
};

export const analytics = {
    name: "analytics",
    icon: "icon-analytics",
    path: "/analytics",
    id: 7
};

export const my_reports = {
    name: "reports",
    icon: "icon-my-reports",
    path: "/my-reports",
    id: 9
};

export const logistics_tools = {
    name: "logistic_tools",
    icon: "icon-logistics-tools",
    path: "/logistics-tools",
    id: 16
};

export const my_profile = {
    name: "my_profile",
    icon: "icon-user",
    path: "/my-profile",
    id: 8
};

export const admin = {
    name: "admin",
    icon: "icon-admin",
    id: 17,
    submenu: [
        { name: "alert_notification", path: "/alerts-notifications" },
        { name: "users", path: "/users" },
    ],
};

export const service_desk = {
    name: "Service desk",
    icon: "icon-question-circle-o",
    path: "/service-desk",
    id: 18
};

export const MODULES = {
    dashboard: dashboard,
    po_visibility: po_visibility,
    po_management: po_management,
    supplier_management: supplier_management,
    entity_association: entity_association,
    transport_plans: transport_plans,
    shipments_visibility: shipments_visibility,
    finance: finance,
    time_sensitive: time_sensitive,
    analytics: analytics,
    my_reports: my_reports,
    logistics_tools: logistics_tools,
    my_profile: my_profile,
    admin: admin,
    service_desk: service_desk,
};

export const MENU_HANDLER = {

    1: [
        'dashboard',
        'po_visibility',
        'po_management',
        'supplier_management',
        'entity_association',
        'transport_plans',
        'shipments_visibility',
        'finance',
        'time_sensitive',
        'analytics',
        'my_reports',
        'logistics_tools',
        'my_profile',
        'admin',
        'service_desk'
    ],
    2: [
        'dashboard',
        'po_visibility',
        'po_management',
        'entity_association',
        'transport_plans',
        'shipments_visibility',
        'finance',
        'time_sensitive',
        'analytics',
        'my_reports',
        'logistics_tools',
        'my_profile',
    ],
    3: [
        'dashboard',
        'po_visibility',
        'po_management',
        'entity_association',
        'transport_plans',
        'shipments_visibility',
        'finance',
        'time_sensitive',
        'analytics',
        'my_reports',
        'logistics_tools',
        'my_profile',
    ],
    4: [
        'dashboard',
        'po_visibility',
        'po_management',
        'entity_association',
        'transport_plans',
        'shipments_visibility',
        'finance',
        'time_sensitive',
        'analytics',
        'my_reports',
        'logistics_tools',
        'my_profile',
    ],
    5: [
        'dashboard',
        'po_visibility',
        'po_management',
        'transport_plans',
        'shipments_visibility',
        'finance',
        'time_sensitive',
        'analytics',
        'my_reports',
        'logistics_tools',
        'my_profile',
    ],
    6: [
        'dashboard',
        'po_visibility',
        'po_management',
        'transport_plans',
        'shipments_visibility',
        'finance',
        'time_sensitive',
        'analytics',
        'my_reports',
        'logistics_tools',
        'my_profile',
    ],
    7: [
        'dashboard',
        'po_visibility',
        'po_management',
        'shipments_visibility',
        'my_profile'
    ],
    8: [
        'supplier_management',
        'my_profile'
    ],
    9: [
        'dashboard',
        'po_visibility',
        'po_management',
        'supplier_management',
        'transport_plans',
        'shipments_visibility',
        'finance',
        'time_sensitive',
        'analytics',
        'my_reports',
        'logistics_tools',
        'my_profile',
    ],
};

export const RolesWithConfigurableModules = {
    5: [
        'po_visibility',
        'po_management',
        'transport_plans',
        'finance',
        'analytics',
        'time_sensitive'
    ],
    6: [
        'po_visibility',
        'po_management',
        'transport_plans',
        'finance',
        'analytics',
        'time_sensitive'
    ],
    7: [
        'po_visibility',
        'po_management',
        'transport_plans',
        // 'finance',
        'analytics',
        'time_sensitive'
    ],
    9: [
        'po_visibility',
        'po_management',
        'transport_plans',
        'finance',
        'analytics',
        'time_sensitive'
    ],
};
